/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateRequest,
  GetNotificationsParams,
  InAppNotificationDTO,
  NotificationStats,
  PageInAppNotificationDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Mark a specific notification as read
 * @summary Mark notification as read
 */
export const markAsRead = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/notifications/in-app/${id}/read`, method: 'PUT'
    },
      options);
    }
  


export const getMarkAsReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAsRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markAsRead>>, TError,{id: number}, TContext> => {

const mutationKey = ['markAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAsRead>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markAsRead(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAsRead>>>
    
    export type MarkAsReadMutationError = unknown

    /**
 * @summary Mark notification as read
 */
export const useMarkAsRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAsRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAsRead>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getMarkAsReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Mark a specific notification as attended and clear group if applicable
 * @summary Mark notification as attended
 */
export const markAsAttended = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/notifications/in-app/${id}/attended`, method: 'PUT'
    },
      options);
    }
  


export const getMarkAsAttendedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAsAttended>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markAsAttended>>, TError,{id: number}, TContext> => {

const mutationKey = ['markAsAttended'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAsAttended>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markAsAttended(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkAsAttendedMutationResult = NonNullable<Awaited<ReturnType<typeof markAsAttended>>>
    
    export type MarkAsAttendedMutationError = unknown

    /**
 * @summary Mark notification as attended
 */
export const useMarkAsAttended = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAsAttended>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAsAttended>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getMarkAsAttendedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Mark all notifications as read for the authenticated user
 * @summary Mark all notifications as read
 */
export const markAllAsRead = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<number>(
      {url: `/api/notifications/in-app/read-all`, method: 'PUT'
    },
      options);
    }
  


export const getMarkAllAsReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllAsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllAsRead>>, TError,void, TContext> => {

const mutationKey = ['markAllAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllAsRead>>, void> = () => {
          

          return  markAllAsRead(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkAllAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllAsRead>>>
    
    export type MarkAllAsReadMutationError = unknown

    /**
 * @summary Mark all notifications as read
 */
export const useMarkAllAsRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllAsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAllAsRead>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getMarkAllAsReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Retrieve paginated notifications for the authenticated user
 * @summary Get notifications for current user
 */
export const getNotifications = (
    params?: GetNotificationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageInAppNotificationDTO>(
      {url: `/api/notifications/in-app`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetNotificationsInfiniteQueryKey = (params?: GetNotificationsParams,) => {
    return [
    'infinite', `/api/notifications/in-app`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetNotificationsQueryKey = (params?: GetNotificationsParams,) => {
    return [
    `/api/notifications/in-app`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetNotificationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNotifications>>>, TError = unknown>(params?: GetNotificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) => getNotifications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsInfiniteQueryError = unknown


export function useGetNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotifications>>>, TError = unknown>(
 params: undefined |  GetNotificationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotifications>>>, TError = unknown>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotifications>>>, TError = unknown>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get notifications for current user
 */

export function useGetNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotifications>>>, TError = unknown>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) => getNotifications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsQueryError = unknown


export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
 params: undefined |  GetNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get notifications for current user
 */

export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new in-app notification
 * @summary Create notification
 */
export const createNotification = (
    createRequest: CreateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InAppNotificationDTO>(
      {url: `/api/notifications/in-app`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRequest, signal
    },
      options);
    }
  


export const getCreateNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotification>>, TError,{data: CreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createNotification>>, TError,{data: CreateRequest}, TContext> => {

const mutationKey = ['createNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNotification>>, {data: CreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createNotification(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof createNotification>>>
    export type CreateNotificationMutationBody = CreateRequest
    export type CreateNotificationMutationError = unknown

    /**
 * @summary Create notification
 */
export const useCreateNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotification>>, TError,{data: CreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNotification>>,
        TError,
        {data: CreateRequest},
        TContext
      > => {

      const mutationOptions = getCreateNotificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Retrieve a specific notification by its ID
 * @summary Get notification by ID
 */
export const getNotificationById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InAppNotificationDTO>(
      {url: `/api/notifications/in-app/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetNotificationByIdInfiniteQueryKey = (id?: number,) => {
    return [
    'infinite', `/api/notifications/in-app/${id}`
    ] as const;
    }

export const getGetNotificationByIdQueryKey = (id?: number,) => {
    return [
    `/api/notifications/in-app/${id}`
    ] as const;
    }

    
export const getGetNotificationByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNotificationById>>>, TError = unknown>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationByIdInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationById>>> = ({ signal }) => getNotificationById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationById>>>
export type GetNotificationByIdInfiniteQueryError = unknown


export function useGetNotificationByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationById>>>, TError = unknown>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationById>>,
          TError,
          Awaited<ReturnType<typeof getNotificationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationById>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationById>>,
          TError,
          Awaited<ReturnType<typeof getNotificationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationById>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get notification by ID
 */

export function useGetNotificationByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationById>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetNotificationByIdQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationById>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationById>>> = ({ signal }) => getNotificationById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationById>>>
export type GetNotificationByIdQueryError = unknown


export function useGetNotificationById<TData = Awaited<ReturnType<typeof getNotificationById>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationById>>,
          TError,
          Awaited<ReturnType<typeof getNotificationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationById<TData = Awaited<ReturnType<typeof getNotificationById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationById>>,
          TError,
          Awaited<ReturnType<typeof getNotificationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationById<TData = Awaited<ReturnType<typeof getNotificationById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get notification by ID
 */

export function useGetNotificationById<TData = Awaited<ReturnType<typeof getNotificationById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete a specific notification
 * @summary Delete notification
 */
export const deleteNotification = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/notifications/in-app/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotification>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNotification>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNotification>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteNotification(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNotification>>>
    
    export type DeleteNotificationMutationError = unknown

    /**
 * @summary Delete notification
 */
export const useDeleteNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotification>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNotification>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteNotificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get notification counts and statistics for the authenticated user
 * @summary Get notification statistics
 */
export const getNotificationStats = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationStats>(
      {url: `/api/notifications/in-app/stats`, method: 'GET', signal
    },
      options);
    }
  



export const getGetNotificationStatsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/notifications/in-app/stats`
    ] as const;
    }

export const getGetNotificationStatsQueryKey = () => {
    return [
    `/api/notifications/in-app/stats`
    ] as const;
    }

    
export const getGetNotificationStatsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNotificationStats>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationStatsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationStats>>> = ({ signal }) => getNotificationStats(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationStatsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationStats>>>
export type GetNotificationStatsInfiniteQueryError = unknown


export function useGetNotificationStatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationStats>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationStats>>,
          TError,
          Awaited<ReturnType<typeof getNotificationStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationStatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationStats>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationStats>>,
          TError,
          Awaited<ReturnType<typeof getNotificationStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationStatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationStats>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get notification statistics
 */

export function useGetNotificationStatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationStats>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationStatsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetNotificationStatsQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationStats>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationStats>>> = ({ signal }) => getNotificationStats(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationStats>>>
export type GetNotificationStatsQueryError = unknown


export function useGetNotificationStats<TData = Awaited<ReturnType<typeof getNotificationStats>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationStats>>,
          TError,
          Awaited<ReturnType<typeof getNotificationStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationStats<TData = Awaited<ReturnType<typeof getNotificationStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationStats>>,
          TError,
          Awaited<ReturnType<typeof getNotificationStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationStats<TData = Awaited<ReturnType<typeof getNotificationStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get notification statistics
 */

export function useGetNotificationStats<TData = Awaited<ReturnType<typeof getNotificationStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




